import * as api from '../../api';
import { normalize } from 'normalizr';
import * as schema from '../schema';
import { getIsFetching } from './reducers.js';

export const fetchMediaLists = (pageType, pathname, querystring) => (
  dispatch,
  getState
) => {
  if (getIsFetching(getState(), pathname)) {
    return Promise.resolve();
  }
  dispatch({
    type: 'FETCH_LISTS_REQUEST',
    pageType,
    pathname,
    querystring,
  });

  return api
    .fetchMediaLists(pageType, querystring)
    .then(
      response => {
        if (response.lists && response.lists.length) {
          dispatch({
            type: 'FETCH_LISTS_SUCCESS',
            pathname,
            response: normalize(response, schema.arrayOfLists),
          });
        } else {
          let errorObj = response.error
            ? response.error
            : { message: 'Unknown Error' };
          if (typeof Raven !== 'undefined')
            Raven.captureException(errorObj.message);
          dispatch({
            type: 'FETCH_LISTS_FAILURE',
            pathname,
            error: errorObj,
            message: errorObj.message,
          });
        }
      },
      error => {
        // console.log(error);
        if (typeof Raven !== 'undefined') Raven.captureException(error);
        let errorObj = error.error ? error.error : { message: 'Unknown Error' };
        dispatch({
          type: 'FETCH_LISTS_FAILURE',
          pathname,
          error: errorObj,
          message: errorObj.message,
        });
      }
    )
    .catch(err => {
      console.log('catch', err);
    });
};
